import { DateTimeInput } from "@/components/FormInputs/DateTimeInput";
import React from "react";
import { useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { InputWrapper } from "@/components/FormInputs/InputWrapper";
import { addYears } from "date-fns";
import { useNow } from "@/hooks/useNow";

interface DateTimeSchedulerProps {
  timeZone?: string;
  name: string;
  label: string;
  nowOverride?: Date;
  disabled?: boolean;
  defaultMonth?: Date;
}

export function DateTimeScheduler({
  timeZone,
  name,
  label,
  disabled,
  defaultMonth,
}: DateTimeSchedulerProps) {
  const { t } = useTranslation("translation", {
    keyPrefix: "bulkMessaging.composeMessage.inputs.date",
  });

  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    rules: { required: { value: true, message: t("requiredError") } },
  });

  const now = useNow();

  return (
    <InputWrapper label={label} name={name} error={error}>
      <DateTimeInput
        value={field.value}
        defaultMonth={defaultMonth}
        onUpdate={field.onChange}
        placeholder={t("placeholder")}
        timeZone={timeZone}
        disabled={
          disabled || { before: new Date(now), after: addYears(now, 1) }
        }
      />
    </InputWrapper>
  );
}
